<template>
  <div id="app">
    <div class="example">
      <b-card>
        <b-card-header>
          <b-card-title>Project Status</b-card-title>
        </b-card-header>
        <apexchart 
          type="donut"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  props: {
    statusData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
          height: 350,
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        labels: [],
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: 'gradient',
        },
        legend: {
          formatter: function (val, opts) {
            return `${val} - ${opts.w.globals.series[opts.seriesIndex]}`;
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return `${value} tasks`;
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    };
  },
  watch: {
    statusData: {
      handler(newData) {
        console.log("New data received:", newData);
        this.processDonutData(newData);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    processDonutData(data) {
      if (!data || data.length === 0) return;
      
      const labels = data.map(item => this.formatStatus(item.status));
      const quantities = data.map(item => item.quantity);

      this.chartOptions = {
        ...this.chartOptions,
        labels: labels
      };
      
      this.series = quantities;
    },
    
    formatStatus(status) {
      if (!status) return '';
      
      return status
        .split('_')
        .join(' ')
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
    }
  }
};
</script>

<style>
.example {
  margin: 20px;
}
</style>